function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 21,
  x2: 4,
  y2: 14
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 10,
  x2: 4,
  y2: 3
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 21,
  x2: 12,
  y2: 12
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 8,
  x2: 12,
  y2: 3
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 21,
  x2: 20,
  y2: 16
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 12,
  x2: 20,
  y2: 3
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 14,
  x2: 7,
  y2: 14
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 8,
  x2: 15,
  y2: 8
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 17,
  y1: 16,
  x2: 23,
  y2: 16
});

var SvgSliders = function SvgSliders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sliders",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSliders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sliders.d4aabd40.svg";
export { ForwardRef as ReactComponent };